import React, { useMemo } from "react";
import Loader from "../../components/Loader";

const fmtDate = (date) => {
    if (!date) return "—";

    try {
        return new Date(date).toLocaleString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch (_error) {
        return "—";
    }
};

const getStatus = (user) => {
    if (user?.isActive === false && user?.isActivated === false) {
        return <span className="listGrid__status is-warning">Ожидает подтверждения</span>;
    }

    if (user?.isActive === false) {
        return <span className="listGrid__status is-danger">Отключён</span>;
    }

    if (user?.isActivated === false) {
        return <span className="listGrid__status is-warning">Email не подтверждён</span>;
    }

    return <span className="listGrid__status is-success">Активен</span>;
};

const COLUMNS = {
    users: [
        { key: "role", label: "Роль", render: (user) => user.role },
        { key: "firstName", label: "Имя", render: (user) => user.firstName },
        { key: "lastName", label: "Фамилия", render: (user) => user.lastName },
        { key: "email", label: "Email", render: (user) => user.email },
        { key: "status", label: "Статус", render: getStatus },
        { key: "createdAt", label: "Зарегистрирован", render: (user) => fmtDate(user.createdAt) },
    ],
    partners: [
        { key: "fio", label: "ФИО", render: (user) => `${user.firstName} ${user.lastName}`.trim() },
        { key: "email", label: "Email", render: (user) => user.email },
        { key: "phone", label: "Телефон", render: (user) => user.contactNumber || "—" },
        { key: "org", label: "Организация", render: (user) => user.nameOrganization || "—" },
        { key: "status", label: "Статус", render: () => <span className="listGrid__status">Партнёр</span> },
        { key: "createdAt", label: "Зарегистрирован", render: (user) => fmtDate(user.createdAt) },
    ],
};

const CARD_FIELDS = {
    users: [
        { label: "Роль", render: (user) => user.role },
        { label: "Имя", render: (user) => user.firstName },
        { label: "Фамилия", render: (user) => user.lastName },
        { label: "Email", render: (user) => user.email },
        { label: "Статус", render: getStatus },
    ],
    partners: [
        { label: "ФИО", render: (user) => `${user.firstName} ${user.lastName}`.trim() },
        { label: "Email", render: (user) => user.email },
        { label: "Телефон", render: (user) => user.contactNumber || "—" },
        { label: "Организация", render: (user) => user.nameOrganization || "—" },
    ],
};

const CARD_FOOTER = {
    users: (user) => ({ left: user.role, right: fmtDate(user.createdAt) }),
    partners: (user) => ({ left: "Партнёр", right: fmtDate(user.createdAt) }),
};

const RenderUsers = ({
    users = [],
    variant = "users",
    showUserDetailsModal,
    onOpen,
    loading = false,
    pageNumber = 0,
    pageSize = 12,
}) => {
    const open = onOpen || showUserDetailsModal;
    const columns = useMemo(() => COLUMNS[variant] || COLUMNS.users, [variant]);
    const cardFields = useMemo(() => CARD_FIELDS[variant] || CARD_FIELDS.users, [variant]);
    const cardFooter = CARD_FOOTER[variant] || CARD_FOOTER.users;
    const baseIndex = (Number(pageNumber) || 0) * (Number(pageSize) || 0);

    if (loading) return <Loader />;
    if (!users || users.length === 0) {
        return <div className="listGrid__empty">Ничего не найдено.</div>;
    }

    return (
        <div className="listGrid">
            <div className="listGrid__tableWrap">
                <table className="listGrid__table">
                    <thead>
                        <tr>
                            <th>#</th>
                            {columns.map((column) => (
                                <th key={column.key}>{column.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr
                                key={user._id || index}
                                onClick={() => open && open(user._id, "details")}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{baseIndex + index + 1}</td>
                                {columns.map((column) => (
                                    <td key={column.key}>{column.render(user)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="listGrid__cards">
                {users.map((user, index) => {
                    const footer = cardFooter(user);

                    return (
                        <div
                            className="listCard"
                            key={user._id || index}
                            onClick={() => open && open(user._id, "details")}
                            role="button"
                        >
                            {cardFields.map((field, fieldIndex) => (
                                <div className="listCard__line" key={fieldIndex}>
                                    <span className="listCard__label">{field.label}:</span>
                                    <span className="listCard__value">{field.render(user)}</span>
                                </div>
                            ))}
                            <div className="listCard__footer">
                                <span className="listCard__status">{footer.left}</span>
                                <span className="listCard__date">{footer.right}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RenderUsers;
